export default "__VITE_ASSET__CNQq33sZ__"